// extracted by mini-css-extract-plugin
module.exports = {"container":"BQ","imgContainer":"CQ","content":"DQ","brand":"EQ","product":"FQ","price":"GQ","noLink":"HQ"};